import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner, Container, Row, Col } from "react-bootstrap";
import { showMyAlert } from "./alertService";

const PermissionChecker = ({ permission, children }) => {
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(false);
  const navigate = useNavigate();

  const userId =
    sessionStorage.getItem("userId") || localStorage.getItem("userId");

  useEffect(() => {
    if (!userId) {
      // If no user ID found, redirect to login
      navigate("/login");
                    showMyAlert({
        type: "warning",              // "success" | "danger" | "warning" | "info"
        title: "Authentication Needed",
        message: "Please authenticate yourself to access this page",
        duration: 2500,               // auto-close in 2.5s
      });
      return;
    }
    fetchUser();
  }, [userId, permission]);

  const fetchUser = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `https://api.dremerz.net/api/DZ_8922_Payroll_PayrollCreateAdmin_PayrollAdminList/${userId}`
      );
      setUser(res.data);

      if (res.data && res.data.permissions) {
        const userPermissions = res.data.permissions.split(",");
        const hasRequiredPermission = userPermissions.includes(permission);
        setHasPermission(hasRequiredPermission);

        if (!hasRequiredPermission) {
          showMyAlert({
           type: "warning",              // "success" | "danger" | "warning" | "info"
           title: "No Permission",
           message: "You don't have enough permission to access this page",
           duration: 2500,               // auto-close in 2.5s
         });
          navigate("/LandingPage");
        }
      }
    } catch (error) {
      console.error("Failed to check permission:", error);
          showMyAlert({
           type: "warning",              // "success" | "danger" | "warning" | "info"
           title: "No Permission",
           message: "Failed to verify permissions. Please login again.",
           duration: 2500,               // auto-close in 2.5s
         });
      navigate("/LandingPage");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Bootstrap Loading Spinner
  if (loading) {
    return (
      <Container
        fluid
        className="d-flex justify-content-center align-items-center vh-100"
      >
        <Row>
          <Col className="text-center">
            <Spinner
              animation="border"
              role="status"
              variant="primary"
              style={{ width: "3rem", height: "3rem" }}
            />
            <div className="mt-3 text-muted fs-6">
              Loading...
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  // No permission → render nothing
  if (!hasPermission) {
    return null;
  }

  // ✅ Authorized → render content
  return <>{children}</>;
};

export default PermissionChecker;
